import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { useLanguage } from '../context/LanguageContext';

const StyledBackNav = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  a {
    ${({ theme }) => theme.mixins.inlineLink};
    font-family: var(--font-mono);
    font-size: var(--fz-sm);
  }
`;

const BackNav = () => {
  const { language } = useLanguage();
  const isZh = language === 'zh';

  return (
    <StyledBackNav>
      <Link to="/">{isZh ? '← 返回首页' : '← Back to Home'}</Link>
    </StyledBackNav>
  );
};

export default BackNav;
